import { render } from "./EditUserManagementPage.vue?vue&type=template&id=6f771f26"
import script from "./EditUserManagementPage.vue?vue&type=script&lang=js"
export * from "./EditUserManagementPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__